export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プログラムを検索する"])}
    }
  })
}
